<template>
    <div>
        <!--Generic-->
        <AlertModal :modalId="alertId"
                     :controller="controller.alertModal"
                     v-if="controller.alertModal != null"
        ></AlertModal>
        <LoadingModal
                    :modalId="loadingId"
                    :controller="controller.loadingModal"
                    v-if="controller.loadingModal != null"
        ></LoadingModal>
        <ConfirmModal
                    :modalId="confirmId"
                    :controller="controller.confirmModal"
                    v-if="controller.confirmModal != null"
        ></ConfirmModal>
        <SuccessModal :modalId="successId"
                     :controller="controller.successModal"
                     v-if="controller.successModal != null"
        ></SuccessModal>
        <!--Authen-->
        <OtpModal
                    :modalId="otpId"
                    :controller="controller.otpModal"
                    v-if="controller.otpModal != null">
        </OtpModal>
        <!--Redeem-->
        <ConfirmRedeemModal
                    :modalId="confirmRedeemId"
                    :controller="controller.confirmRedeemModal"
                    v-if="controller.confirmRedeemModal != null">
        </ConfirmRedeemModal>
        <DrawDeliveryModal
                    :modalId="drawDeliveryId"
                    :controller="controller.drawDeliveryModal"
                    v-if="controller.drawDeliveryModal != null">
        </DrawDeliveryModal>
        <SerialModal
                    :modalId="serialId"
                    :controller="controller.serialModal"
                    v-if="controller.serialModal != null">
        </SerialModal>
        <ShippingAddressModal
                    :modalId="shippingAddressId"
                    :controller="controller.shippingAddressModal"
                    v-if="controller.shippingAddressModal != null">
        </ShippingAddressModal>
        <!-- custom modal -->
        <ProductDescriptionModal
                    :alertModal="controller.alertModal"
                    :loadingModal="controller.loadingModal"
                    :modalId="productDescriptionId"
                    :controller="controller.productDescriptionModal"
                    v-if="controller.productDescriptionModal != null">
        </ProductDescriptionModal>
        <PointSummaryModal
                    :modalId="pointSummaryId"
                    :controller="controller.pointSummaryModal"
                    v-if="controller.pointSummaryModal != null">
        </PointSummaryModal>
        <SkipModal
                    :modalId="skipId"
                    :controller="controller.skipModal"
                    v-if="controller.skipModal != null">

        </SkipModal>
        <PointCollectionStepModal
                    :modalId="pointCollectionStepId"
                    :controller="controller.pointCollectionStepModal"
                    v-if="controller.pointCollectionStepModal != null">

        </PointCollectionStepModal>
        <WelcomePointModal
                    :modalId="welcomePointId"
                    :controller="controller.welcomePointModal"
                    v-if="controller.welcomePointModal != null">

        </WelcomePointModal>
        <WelcomeCouponModal
                    :modalId="welcomeCouponId"
                    :controller="controller.welcomeCouponModal"
                    v-if="controller.welcomeCouponModal != null">

        </WelcomeCouponModal>
        <SideBarModal
                    :modalId="sideBarId"
                    :controller="controller.sideBarModal"
                    v-if="controller.sideBarModal != null">

        </SideBarModal>
        <FreeDeliverySuccessModal
                    :modalId="freeDeliverySuccessId"
                    :controller="controller.freeDeliverySuccessModal"
                    v-if="controller.freeDeliverySuccessModal != null">
        </FreeDeliverySuccessModal>
        <ConfirmDeliveryAddressModal
                    :modalId="confirmDeliveryAddressId"
                    :controller="controller.confirmDeliveryAddressModal"
                    v-if="controller.confirmDeliveryAddressModal != null">
        </ConfirmDeliveryAddressModal>
        <PointCollectionModal
                    :modalId="pointCollectionId"
                    :controller="controller.pointCollectionModal"
                    v-if="controller.pointCollectionModal != null">
        </PointCollectionModal>
        <AlertRegisterModal :modalId="alertRegisterId"
                     :controller="controller.alertRegisterModal"
                     v-if="controller.alertRegisterModal != null"
        ></AlertRegisterModal>
        <TermModal :modalId="termId"
                    :controller="controller.termModal"
                    v-if="controller.termModal != null"
        ></TermModal>
        <MissionSuccessModal :modalId="missionSuccessId"
                    :controller="controller.missionSuccessModal"
                    v-if="controller.missionSuccessModal != null">
        </MissionSuccessModal>
        <MissionSuccessCheckinModal :modalId="missionSuccessCheckinId"
                    :controller="controller.missionSuccessCheckinModal"
                    v-if="controller.missionSuccessCheckinModal != null">
        </MissionSuccessCheckinModal>
        <CancelMemberModal :modalId="cancelMemberId"
                    :controller="controller.cancelMemberModal"
                    v-if="controller.cancelMemberModal != null">
        </CancelMemberModal>
        <DonateSuccessModal :modalId="donateSuccessId"
                    :controller="controller.donateSuccessModal"
                    v-if="controller.donateSuccessModal != null">
        </DonateSuccessModal>
        <MarketingModal :modalId="marketingId"
                    :controller="controller.marketingModal"
                    v-if="controller.marketingModal != null">
        </MarketingModal>
        <PrivacySettingModal :modalId="privacySettingId"
                    :controller="controller.privacySettingModal"
                    v-if="controller.privacySettingModal != null">
        </PrivacySettingModal>
        <CopyPersonalModal :modalId="copyPersonalId"
                    :controller="controller.copyPersonalModal"
                    v-if="controller.copyPersonalModal != null">
        </CopyPersonalModal>
        <TermsRegisterModal :modalId="termsRegisterId"
                    :controller="controller.termsRegisterModal"
                    v-if="controller.termsRegisterModal != null"
        ></TermsRegisterModal>
        <PrivacyRegisterModal :modalId="privacyRegisterId"
                    :controller="controller.privacyRegisterModal"
                    v-if="controller.privacyRegisterModal != null"
        ></PrivacyRegisterModal>
        <MarketingReConsentModal :modalId="marketingReConsentId"
                    :controller="controller.marketingReConsentModal"
                    v-if="controller.marketingReConsentModal != null"
        ></MarketingReConsentModal>
        <TermsReConsentModal :modalId="termsReConsentId"
                    :controller="controller.termsReConsentModal"
                    v-if="controller.termsReConsentModal != null"
        ></TermsReConsentModal>
        <PrivacyReConsentModal :modalId="privacyReConsentId"
                    :controller="controller.privacyReConsentModal"
                    v-if="controller.privacyReConsentModal != null"
        ></PrivacyReConsentModal>
        <AgeConsentAlertModal :modalId="ageConsentAlertId"
                    :controller="controller.ageConsentAlertModal"
                    v-if="controller.ageConsentAlertModal != null"
        ></AgeConsentAlertModal>
        <LeaderBoardConditionModal :modalId="leaderBoardConditionId"
                    :controller="controller.leaderBoardConditionModal"
                    v-if="controller.leaderBoardConditionModal != null"
        ></LeaderBoardConditionModal>
    </div>
</template>
<script>
//Generic modal
import AlertModal from './Generic/Modal/AlertModal.vue';
import LoadingModal from './Generic/Modal/LoadingModal.vue';
import ConfirmModal from './Generic/Modal/ConfirmModal.vue';
import SuccessModal from './Generic/Modal/SuccessModal.vue';
import AlertRegisterModal from './Generic/Modal/AlertRegisterModal.vue';
//Authen modal
import OtpModal from './Authen/OTP/OtpModal';
//Redeem modal
import ConfirmRedeemModal from './Redeem/ConfirmRedeem/ConfirmRedeemModal.vue';
import DrawDeliveryModal from './Redeem/DrawDelivery/DrawDeliveryModal.vue';
import DonateSuccessModal from './Redeem/DonateSuccess/DonateSuccessModal.vue'
import SerialModal from './Redeem/Serial/SerialModal.vue';
import ShippingAddressModal from './Redeem/ShippingAddress/ShippingAddressModal.vue';
import FreeDeliverySuccessModal from './Redeem/FreeDelivery/FreeDeliverySuccessModal.vue';
import ConfirmDeliveryAddressModal from './Redeem/ConfirmDeliveryAddress/ConfirmDeliveryAddressModal.vue';
// custom modal
import ProductDescriptionModal from "./Custom/Modal/ProductDescriptionModal.vue";
import PointSummaryModal from "./Custom/Modal/PointSummaryModal.vue";
import SkipModal from "./Custom/Modal/SkipModal.vue";
import PointCollectionStepModal from "./Custom/Modal/PointCollectionStepModal.vue"
import WelcomePointModal from "./Custom/Modal/WelcomePointModal.vue";
import PointCollectionModal from "./Custom/Modal/PointCollectionModal.vue"
import TermModal from "./Custom/Modal/TermModal.vue"
import MissionSuccessModal from "./Custom/Modal/MissionSuccessModal.vue";
import MissionSuccessCheckinModal from "./Custom/Modal/MissionSuccessCheckinModal.vue";

import CancelMemberModal from "./Custom/Modal/CancelMemberModal.vue";
import MarketingModal from "./Custom/Modal/MarketingModal.vue";
import PrivacySettingModal from "./Custom/Modal/PrivacySettingModal.vue";
import CopyPersonalModal from "./Custom/Modal/CopyPersonalModal.vue";
import TermsRegisterModal from "./Custom/Modal/TermsRegisterModal.vue";
import PrivacyRegisterModal from "./Custom/Modal/PrivacyRegisterModal.vue";
import AgeConsentAlertModal from "./Custom/Modal/AgeConsentAlertModal.vue";
import MarketingReConsentModal from "./Custom/Modal/MarketingReConsentModal.vue";
import TermsReConsentModal from "./Custom/Modal/TermsReConsentModal.vue";
import PrivacyReConsentModal from "./Custom/Modal/PrivacyReConsentModal.vue";
import LeaderBoardConditionModal from './Custom/Modal/LeaderBoardConditionModal.vue';
import WelcomeCouponModal from './Custom/Modal/WelcomeCouponModal.vue';
/**
 * @property {ModalController} controller (required) /components/Modal/Controller/ModalController.js
 */
export default {
    name: 'ModalMaster',
    props: {
        controller: Object,
    },
    components: {
        //generic
        AlertModal,
        LoadingModal,
        ConfirmModal,
        SuccessModal,
        //Authen
        OtpModal,
        //Redeem
        ConfirmRedeemModal,
        DrawDeliveryModal,
        SerialModal,
        ShippingAddressModal,
        FreeDeliverySuccessModal,
        ConfirmDeliveryAddressModal,
        //custom
        ProductDescriptionModal,
        PointSummaryModal,
        SkipModal,
        PointCollectionStepModal,
        WelcomePointModal,
        PointCollectionModal,
        AlertRegisterModal,
        TermModal,
        MissionSuccessModal,
        MissionSuccessCheckinModal,
        CancelMemberModal,
        DonateSuccessModal,
        MarketingModal,
        PrivacySettingModal,
        CopyPersonalModal,
        TermsRegisterModal,
        PrivacyRegisterModal,
        AgeConsentAlertModal,
        MarketingReConsentModal,
        TermsReConsentModal,
        PrivacyReConsentModal,
        LeaderBoardConditionModal,
        WelcomeCouponModal,
    },
    data: function() {
        return {
            randomNum: Math.floor(Math.random() * 100000) + '',
            //generic
            alertId: '',
            loadingId: '',
            confirmId: '',
            successId: '',
            //authen
            otpId: '',
            //redeem
            confirmRedeemId: '',
            drawDeliveryId: '',
            serialId: '',
            shippingAddressId: '',
            freeDeliverySuccessId: '',
            confirmDeliveryAddressId: '',
            // custom
            productDescriptionId: '',
            pointSummaryId: '',
            skipId: '',
            pointCollectionStepId: '',
            welcomePointId: '',
            pointCollectionId: '',
            alertRegisterId: '',
            termId: '',
            missionSuccessId: '',
            missionSuccessCheckinId: '',
            cancelMemberId: '',
            donateSuccessId: '',
            marketingId: '',
            privacySettingId: '',
            copyPersonalId: '',
            termsRegisterId: '',
            privacyRegisterId: '',
            ageConsentAlertId: '',
            marketingReConsentId: '',
            termsReConsentId: '',
            privacyReConsentId: '',
            leaderBoardConditionId: '',
            welcomeCouponId: '',
        };
    },
    created: function() {
        //generic
        this.alertId = 'alert_modal_' + this.randomNum;
        this.loadingId = 'loading_modal_' + this.randomNum;
        this.confirmId = 'confirm_modal_' + this.randomNum;
        this.successId = 'success_modal_' + this.randomNum;
        //authen
        this.otpId = 'otp_modal_' + this.randomNum;
        //redeem
        this.confirmRedeemId = 'confirm_redeem_modal_' + this.randomNum;
        this.drawDeliveryId = 'draw_delivery_modal_' + this.randomNum;
        this.donateSuccessId = 'donate_success_modal_' + this.randomNum;
        this.serialId = 'serial_modal_' + this.randomNum;
        this.shippingAddressId = 'shipping_address_modal_' + this.randomNum;
        this.freeDeliverySuccessId = 'free_delivery_success_modal_' + this.randomNum;
        this.confirmDeliveryAddressId = 'modal_confirm_delivery_address_' + this.randomNum;
        // custom
        this.productDescriptionId = 'product_desc_modal_' + this.randomNum;
        this.pointSummaryId = 'point_summary_modal_' + this.randomNum;
        this.skipId = 'skip_modal_' + this.randomNum;
        this.pointCollectionStepId = 'point_collection_step_' + this.randomNum;
        this.welcomePointId = 'welcome_point_modal_' + this.randomNum;
        this.pointCollectionId = 'point_collection_' + this.randomNum;
        this.alertRegisterId = 'alert_register_modal_' + this.randomNum;
        this.termId = 'term_modal_' + this.randomNum;
        this.missionSuccessId = 'mission_success_modal_' + this.randomNum;
        this.missionSuccessCheckinId = 'mission_checkin_success_modal_' + this.randomNum;
        this.cancelMemberId = 'cancel_menber_modal_' + this.randomNum;
        this.marketingId = 'marketing_modal_' + this.randomNum;
        this.privacySettingId = 'privacy_setting_modal_' + this.randomNum;
        this.copyPersonalId = 'copy_personal_modal_' + this.randomNum;
        this.termsRegisterId = 'terms_register_modal_' + this.randomNum;
        this.privacyRegisterId = 'privacy_register_modal_' + this.randomNum;
        this.ageConsentAlertId = 'age_consent_modal_' + this.randomNum;
        this.marketingReConsentId = 're_consent_marketing_modal_' + this.randomNum;
        this.termsReConsentId = 'terms_re_modal_' + this.randomNum;
        this.privacyReConsentId = 'privacy_re_modal_' + this.randomNum;
        this.leaderBoardConditionId = 'leaderboard_condition_modal_' + this.randomNum;
        this.welcomeCouponId = 'welcome_coupon_modal_' + this.randomNum;
    }
}
</script>
